export default __webpack_public_path__ + "static/Group 1716-ec3427c1da91263982a87d275fe65028.png";